﻿module.exports = DonationDetailsRepository;

function DonationDetailsRepository(storage) {
    if (!storage) {
        throw new Error("DontaionDetailsRepository storage must be specified");
    }
    this.storage = storage;
}

DonationDetailsRepository.prototype = {
    set(id, data) {
        const serializedData = JSON.stringify(data);
        const key = this.getItemKey(id);
        
        this.storage.setItem(key, serializedData);
    },

    get(id) {
        const key = this.getItemKey(id);
        const serializedData = this.storage.getItem(key);

        return JSON.parse(serializedData);
    },

    getItemKey(id) {
        return `jnf-donation-${id}`;
    }
}